import { render, staticRenderFns } from "./calendar-item.vue?vue&type=template&id=4c6b8f2f"
import script from "./calendar-item.vue?vue&type=script&lang=js"
export * from "./calendar-item.vue?vue&type=script&lang=js"
import style0 from "./calendar-item.vue?vue&type=style&index=0&id=4c6b8f2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports